import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { CabsProfileService } from 'src/app/features/cabs/service/cabs-profile.service';
import { ProfileService } from 'src/app/features/user-management/service/profile.service';
import { whiteSpaceValidator } from 'src/app/shared/Validators/no-white-space';
import { SharedService } from '../../service/shared.service';
import { ToastrService } from 'ngx-toastr';
import { CabsListService } from 'src/app/features/cabs/service/cabs-list.service';
import { emailDetailedValidator } from 'src/app/shared/Validators/mail-custom-validator';

@Component({
  selector: 'app-add-new-entity-profile',
  templateUrl: './add-new-entity-profile.component.html',
  styles: [
  ]
})
export class AddNewEntityProfileComponent implements OnInit {

  loading = false;
  selectedRoleName: any = {};
  editCabsMainInfo: FormGroup;
  countryCodes: any[] = [];
  countryCode: any;
  countries: [] = [];
  cities: [] = [];
  maxDate = new Date();

  // image file
  logo: any;
  logoSrc: string;

  selectedOption: any[] = [];
  selectedNationality;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;

  isSubmitted = false;

  urlPattern =
    /^(https?:\/\/|(www|WWW)\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+\/?.*$/
  // /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,6})+(\/\S*)?$/
  // /^(https?:\/\/|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,6})+(\/\S*)?$/
  // /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  fileTypeError: boolean = false;
  fileSizeError: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddNewEntityProfileComponent>,
    private profileService: ProfileService,
    private cabsProfileService: CabsProfileService,
    private service: CabsListService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
    this.FormInit();
    this.onGetCountryCode();
  }


  FormInit() {
    this.editCabsMainInfo = this.formBuilder.group({
      cabNameEnglish: [
        '',
        [
          Validators.required,

          whiteSpaceValidator,
        ],
      ],

      address: ['', [Validators.required]],
      region: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      zipCode: ['', [Validators.minLength(2)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      fax: ['', [Validators.minLength(10)]],
      email: [
        '',
        [
          Validators.email,
          // Validators.pattern(
          //   '[a-zA-Z0-9._-]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}'
          // ),
          Validators.required,
          emailDetailedValidator()
        ],
      ],

      website: ['', [Validators.required, Validators.pattern(this.urlPattern)]],

    });
  }

  hasError(controlName: string, errorName: string) {
    return this.editCabsMainInfo.controls[controlName].hasError(errorName);
  }

  onCabsMainlInfoSubmit() {
    this.isSubmitted = true;
    if (!this.logo && !this.logoSrc) {
      return;
    }

    this.onFilterByCountryCode();
    if (this.editCabsMainInfo.valid) {

      const modal = {
        cab_name_en: this.editCabsMainInfo.controls.cabNameEnglish.value,
        cab_address: this.editCabsMainInfo.controls.address.value,
        cab_reigon: this.editCabsMainInfo.controls.region.value,
        cab_city: this.editCabsMainInfo.controls.city.value,
        country_token: this.editCabsMainInfo.controls.country.value,
        cab_po_box: this.editCabsMainInfo.controls.zipCode.value,
        cab_phone: this.editCabsMainInfo.controls.phone.value?.nationalNumber,
        phone_token: this.editCabsMainInfo.controls.phone.value?.countryCode,
        cab_fax: this.editCabsMainInfo.controls.fax.value?.nationalNumber ? this.editCabsMainInfo.controls.fax.value?.nationalNumber : '',
        fax_token: this.editCabsMainInfo.controls.fax.value?.countryCode ? this.editCabsMainInfo.controls.fax.value?.countryCode : '',
        cab_email: this.editCabsMainInfo.controls.email.value,
        cab_website: this.editCabsMainInfo.controls.website.value,
      };
      this.onEditPersonalInfoStaff(modal, this.logo);
    }
  }

  onEditPersonalInfoStaff(modal, imgUpload) {
    this.loading = true;
    this.service.AddNewEntity(modal, imgUpload).subscribe(
      (res) => {
        this.loading = false;
        this.dialogRef.close(modal);
      },
      (err) => {
        this.loading = false;
        err.message.forEach((element) => {
          this.showError(element.message);

        });
        // tslint:disable-next-line: prefer-for-of
        // for (let i = 0; i < err.message.length; i++) {
        //   if (err.message[i].field == 'email') {
        //     this.editCabsMainInfo.controls.email.setErrors({
        //       serverError: `${err.message[i].message}`,
        //     });
        //     this.editCabsMainInfo.updateValueAndValidity();
        //   }
        //   if (err.message[i].field == 'national_id') {
        //     this.editCabsMainInfo.controls.nationalId.setErrors({
        //       serverError: `${err.message[i].message}`,
        //     });
        //   }
        //   if (err.message[i].field == 'passport') {
        //     this.editCabsMainInfo.controls.passportNumber.setErrors({
        //       serverError: `${err.message[i].message}`,
        //     });
        //   }
        //   if (err.message[i].field == 'first_name') {
        //     this.editCabsMainInfo.controls.firstName.setErrors({
        //       serverError: `${err.message[i].message}`,
        //     });
        //   }
        // }
      }
    );
  }

  onGetCountryCode() {
    this.profileService.getCountryCode().subscribe((res) => {
      this.countryCodes = res.data;
    });
  }

  onFilterByCountryCode() {
    const countryCodeValue =
      this.editCabsMainInfo.controls.phone.value.countryCode;
    this.countryCode = this.countryCodes.filter((item) => {
      return item.country_iso_code == countryCodeValue;
    });
  }

  regionCompare(o1, o2) {
    return o1 == o2;
  }

  // File preview with validation
  changeFileListener($event): void {
    const file: File = $event.target.files[0];
    if (file) {
      this.readThis(file);
      this.logo = file;
    } else {
      this.logoSrc = undefined;
      this.logo = undefined;
    }
  }

  readThis(file: File): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.logoSrc = myReader.result as string;
    };
  }

  OnSelectLocation(event: { map_lang: number; map_lat: number }) {
    this.editCabsMainInfo.patchValue({ lat: event.map_lat, lang: event.map_lang })
  }

  showError(msg) {
    this.toastr.error(msg);
  }

}
